import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '50rem',
    alignItems: 'center',
    gap: '1rem',
  },
}));

export default useStyles;
